export const excelDateToFormattedString = (date: number): String => {
  return (new Date(Math.round((date - 25569)*86400*1000))).toLocaleDateString();
}
